import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as DashboardRoute from "./dashboard";
import * as TablesRoute from "./tables";
import * as ViewsRoute from "./views";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// Tables is the section this service exists for, so the root lands there rather
// than on the summary — the same call pagews makes for its sites. The sign-in
// flow points at the dashboard and keeps doing so; this is only where `/` goes.
const RootRoute = () => <Redirect to={`/table`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"Repoflow Tables"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "table",
                  label: "Tables",
                  to: `/table`,
                },
                {
                  icon: "search",
                  label: "Views",
                  to: `/view`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                },
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/dashboard`} component={DashboardRoute.Indice} />
                  <Route path={`/table`} component={TablesRoute.Indice} />
                  <Route path={`/view`} component={ViewsRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/table`} component={TablesRoute.Content} />
                <Route path={`/view`} component={ViewsRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
